// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { propComparator } from "../../../global/functions/StringOperations";
import { CompileDatabaseItemtoJsItem } from "../../../account/components/quotes/QuoteCompileFunctions";

import ProductSheetItem from "../../components/quotes/ProductSheetItem";

type PriceSheetsPropsType = {
  priceSheet: { [key: string]: * },
  productSheets: Array<*>
};

class PriceSheets extends Component<PriceSheetsPropsType, *> {
  render(): React$Element<*> {
    const price_list =
      this.props.priceSheet && this.props.priceSheet.parts.edges;
    let baseParts = [];
    price_list.sort(
      propComparator("node", false, "licenceType", null, false, "orderId")
    );
    price_list.map(
      (part: *): * => {
        baseParts.push(CompileDatabaseItemtoJsItem(part.node));
      }
    );

    return (
      <div className="app-wrapper">
        <div className="app-panel">
          <div className="app-panel-content">
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <ProductSheetItem
                  parts={baseParts}
                  name="Base Price Sheet"
                  canEdit
                />
              </Grid>
              {this.props.productSheets &&
                this.props.productSheets.map(
                  (productSheet: *, i: number): * => {
                    let sheetParts = productSheet.sheetParts.edges;
                    let Parts = [];
                    sheetParts.sort(
                      propComparator(
                        "node",
                        false,
                        "part",
                        "licenceType",
                        false,
                        "orderId"
                      )
                    );
                    sheetParts.map(
                      (sheet: *): * => {
                        let tree = { ...sheet.node.part };
                        Parts.push(
                          CompileDatabaseItemtoJsItem(tree, sheet.node)
                        );
                      }
                    );

                    return (
                      <Grid item xs={12} className="top-margin-20" key={i}>
                        <ProductSheetItem
                          productSheet={productSheet}
                          parts={Parts}
                          name={productSheet.description}
                        />
                      </Grid>
                    );
                  }
                )}
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  priceSheet: state.v3account.quote.priceSheet,
  productSheets: state.v3admin.quote.productSheets
});

export default connect(mapStateToProps)(PriceSheets);
